export class AppFile {
  No?: number;
  Type?: string;
  Key?: string;
  Created_DateTime?: string;
  File?: string;
  FileName?: string;

  FileError?: string;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/AppFile.ts